module.exports = __webpack_public_path__ + "img/QQ.babdaed1.png";